import { API_ROUTES } from "@/lib/config/api-routes";
import { ApiService } from "@/lib/services/api-service";
import type {
  BookingExtraMiscellaneousApiResponse,
  BookingExtraMiscellaneousQueryParams,
  BookingMiscellaneousApiResponse,
  BookingMiscellaneousQueryParams,
} from "@/lib/types/miscellaneous";

class MiscellaneousService extends ApiService {
  fetchBookingMiscellaneous(params: BookingMiscellaneousQueryParams) {
    return this.get<BookingMiscellaneousApiResponse>(
      API_ROUTES.bookingMiscellaneous,
      { params },
    );
  }

  fetchBookingExtraMiscellaneous(params: BookingExtraMiscellaneousQueryParams) {
    return this.get<BookingExtraMiscellaneousApiResponse>(
      API_ROUTES.bookingExtraMiscellaneous,
      { params },
    );
  }
}

export const miscellaneousService = new MiscellaneousService();
